import React from 'react'
import { AgentLanguageValue } from '../../agent-language/agent-language'
import { bodyCss } from '../../../legacy-design-system/text'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { AgentFeature } from '../../agent-features'
import { LanguageLabel } from '../../language-label/language-label'

export const nameDataTestID = 'rule-cell-name'
export const nameSuffixDataTestID = 'rule-cell-name-suffix'

export function RuleCell({
  rowData: { name, languages, ruleUuid },
  hasParent = false,
  agentFeatures = []
}: {
  readonly rowData: {
    readonly name: string
    readonly languages: AgentLanguageValue[]
    readonly ruleUuid: string
  }
  readonly hasParent?: boolean
  readonly agentFeatures: AgentFeature[] | undefined
}) {
  const namePrefix = getSemanticRuleNamePrefix(name)

  return (
    <div
      className={
        hasParent
          ? css`
              padding-left: 15px;
            `
          : undefined
      }
    >
      <span
        data-testid={nameDataTestID}
        className={cx(
          bodyCss,
          css`
            color: #000000;
          `
        )}
      >
        {hasParent && namePrefix ? namePrefix : name}
      </span>
      {hasParent && namePrefix && (
        <span
          data-testid={nameSuffixDataTestID}
          className={css`
            font-size: 14px;
            color: ${theme.color.neutral50};
          `}
        >
          {' '}
          - {getSemanticRuleNameSuffix(name)}
        </span>
      )}
      <LanguageLabel
        languages={languages}
        ruleUuid={ruleUuid}
        featureName="protection"
        agentFeatures={agentFeatures}
      />
    </div>
  )
}

/* given: "Command Injection - Chained Commands"
 * returns: "Chained Commands" to be used as prefix in the UI where naming is inverted */
export function getSemanticRuleNamePrefix(
  semanticRuleName: string
): string | undefined {
  const prefix = semanticRuleName.split('-')[1]
  return prefix ? prefix.trim() : undefined
}

/* given: "Command Injection - Chained Commands"
 * returns: "Command Injection" to be used as suffix in the UI where naming is inverted */
export function getSemanticRuleNameSuffix(
  semanticRuleName: string
): string | undefined {
  const suffix = semanticRuleName.split('-')[0]
  return suffix ? suffix.trim() : undefined
}
